import { Stack } from '@chakra-ui/react';
import StreetContainerProps from '@/src/components/UI/StreetContainerType';
import Image from 'next/image';
import Link from 'next/link';
import { FC, useEffect } from 'react';

const StreetContainer: FC<StreetContainerProps> = ({ sid, detailData }) => {
  useEffect(() => {
    (() => {
      //@ts-ignore
      new google.maps.StreetViewPanorama(document.getElementById('street-view') as HTMLElement, {
        position: { lat: parseFloat(detailData.location_latitude!), lng: parseFloat(detailData.location_longitude!) },
        pov: { heading: 0, pitch: 0 },
        zoom: 1,
      });
    })();
  }, []);
  return (
    <div className={'flex flex-1'}>
      <div className={'flex flex-1 h-screen w-full relative'} id={'street-view'}>
        <Link passHref href={`/buy/${sid}/map`}>
          <Stack position={'absolute'} right={15} zIndex={50} bottom={4} w={'15%'}>
            <Image src={'/map.png'} width={360} height={270} objectFit={'contain'} />
          </Stack>
        </Link>
      </div>
    </div>
  );
};
export default StreetContainer;
